/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    lastName?: string;
    /**
     * 
     * @type {number}
     * @memberof UserProfile
     */
    requestLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProfile
     */
    consumedRequests?: number;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    planName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfile
     */
    isFreeDefaultPlan?: boolean;
}

/**
 * Check if a given object implements the UserProfile interface.
 */
export function instanceOfUserProfile(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserProfileFromJSON(json: any): UserProfile {
    return UserProfileFromJSONTyped(json, false);
}

export function UserProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'requestLimit': !exists(json, 'requestLimit') ? undefined : json['requestLimit'],
        'consumedRequests': !exists(json, 'consumedRequests') ? undefined : json['consumedRequests'],
        'planName': !exists(json, 'planName') ? undefined : json['planName'],
        'isFreeDefaultPlan': !exists(json, 'isFreeDefaultPlan') ? undefined : json['isFreeDefaultPlan'],
    };
}

export function UserProfileToJSON(value?: UserProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstName': value.firstName,
        'lastName': value.lastName,
        'requestLimit': value.requestLimit,
        'consumedRequests': value.consumedRequests,
        'planName': value.planName,
        'isFreeDefaultPlan': value.isFreeDefaultPlan,
    };
}

